(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ChatBotMessagesController', chatBotMessagesController);

  chatBotMessagesController.$inject = ['$scope', 'FoundationApi', 'ChatBotMessagesService', 'NotificationService'];

  function chatBotMessagesController ($scope, FoundationApi, ChatBotMessagesService, NotificationService) {
    var vm = this;
    vm.searchMessagesTable = searchMessagesTable;
    vm.titleChatBot = 'ChatBot';
    vm.titleModule = 'Módulo';
    vm.totalMessages = 0;
    vm.add = add;
    vm.chaBotMessages = {};
    vm.saveChatBotMessages = saveChatBotMessages;
    vm.edit = edit;
    vm.params = {};
    vm.deleteChaBotMessages = deleteChaBotMessages;
    vm.updateChatBotMessagesObject = updateChatBotMessagesObject;

    searchMessagesTable();

    function searchMessagesTable () {
      ChatBotMessagesService
        .getMessages(vm.params)
        .$promise
        .then(function (data) {
          if (data) {
            vm.totalMessages = data.length;
            vm.chatBots = data;
          } else {
            NotificationService.errorHandler(data, 'Erro ao carregar Mensagens do ChatBot!');
            vm.totalMessages = 0;
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar Mensagens do ChatBot!');
          vm.totalMessages = 0;
        });
    }

    function updateChatBotMessagesObject () {
      if (vm.chaBotMessages.messages !== '') {
        try {
          $scope.messages = JSON.parse(vm.chaBotMessages.messages);
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
          vm.chatBotMessagesValid = true;
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
          vm.chatBotMessagesValid = false;
        }
      } else {
        $scope.formatting = {};
      }
    };

    function add () {
      document.getElementById('scriptMongoDB').readOnly = false;
      vm.chaBotMessages.messages = '';
      vm.chaBotMessages.chatbot_path = '';
      vm.chaBotMessages.module = '';
      vm.chaBotMessages.Id = '';
      FoundationApi.publish('chatbotModal', 'open');
      updateChatBotMessagesObject();
    }

    function saveChatBotMessages () {
      if (vm.chaBotMessages !== '') {
        chaBotMessages = vm.chaBotMessages;
        ChatBotMessagesService
          .saveMessages(chaBotMessages)
          .$promise
          .then(function (data) {
            searchMessagesTable();
            if (data.success) {
              NotificationService.successHandler(data, 'Mensagem do ChatBot salva com sucesso!');
              FoundationApi.publish('chatbotModal', 'close');
            } else {
              NotificationService.errorHandler(data, data.message);
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao salvar Mensagem do ChatBot!');
          })
      } else {
        NotificationService.errorHandler(null, 'Nenhum dado informado!');
      }
    }

    function deleteChaBotMessages (chatBotMessages) {
      var confirmation = confirm('Deseja confirmar essa operação?')
      if (confirmation) {
        ChatBotMessagesService
          .deleteMessages(chatBotMessages)
          .$promise
          .then(function (data) {
            searchMessagesTable();
            if (data.success) {
              NotificationService.successHandler(data, 'Mensagem do ChatBot deletada com sucesso!');
              FoundationApi.publish('validacao', 'close');
            } else {
              NotificationService.errorHandler(data, 'Erro ao deletar Mensagem do ChatBot!');
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao deletar Mensagem do ChatBot!');
          })
      }
    }

    function edit (messages, cbpath, cbmodule, cbId) {
      document.getElementById('scriptMongoDB').readOnly = false;
      vm.chaBotMessages.messages = JSON.stringify(messages, null, 2);
      vm.chaBotMessages.chatbot_path = cbpath;
      vm.chaBotMessages.module = cbmodule;
      vm.chaBotMessages.Id = cbId;
      updateChatBotMessagesObject();
      FoundationApi.publish('chatbotModal', 'open');
    }
  }
})();
